import { useTheme as useNextTheme, ThemeProvider as NextThemeProvider } from "next-themes";
import { useEffect, useState, ReactNode } from "react";

export type Theme = "dark" | "light";

export function useTheme() {
  const { theme, setTheme, resolvedTheme, systemTheme } = useNextTheme();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  const activeTheme = mounted ? (theme === "system" ? resolvedTheme : theme) : "dark";
  const currentTheme: Theme = activeTheme === "light" ? "light" : "dark";

  const toggleTheme = () => {
    const next = currentTheme === "light" ? "dark" : "light";
    setTheme(next);
  };

  return {
    theme: currentTheme,
    setTheme: (newTheme: Theme) => setTheme(newTheme),
    toggleTheme,
    resolvedTheme,
    systemTheme,
    isMounted: mounted,
  };
}

export const ThemeProvider = NextThemeProvider;
